import React from 'react';
import { WorkflowButton as WorkflowButtonType } from '../../types/workflow.types';

interface WorkflowButtonProps {
  buttons: WorkflowButtonType[];
  onButtonClick: (buttonId: string, buttonLabel?: string) => void;
  disabled?: boolean;
  className?: string;
}

const WorkflowButton: React.FC<WorkflowButtonProps> = ({
  buttons,
  onButtonClick,
  disabled = false,
  className = ''
}) => {
  const handleButtonClick = (button: WorkflowButtonType) => {
    if (!disabled) {
      onButtonClick(button.id, button.label);
    }
  };

  return (
    <div className={`flex flex-col ${className}`}>
      {buttons.map((button) => (
        <div
          key={button.id}
          onClick={() => handleButtonClick(button)}
          role="button"
          tabIndex={disabled ? -1 : 0}
          className={`
            px-4 py-3 border-t transition-all duration-200 text-center flex items-center justify-center gap-2 text-sm
            ${disabled
              ? 'text-gray-400 cursor-not-allowed border-gray-200'
              : 'text-gray-700 border-gray-300 cursor-pointer'
            }
          `}
        >
           <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1594_12542)">
              <path d="M0.791324 5.5004L5.42007 9.92428V8.09733C5.42007 7.93214 5.54859 7.79587 5.7132 7.77954C7.36121 7.45907 8.85855 7.45533 10.2211 7.8612C11.3181 8.18809 12.3211 8.77735 13.2374 9.67717C12.9484 7.92813 12.2046 6.46501 11.0871 5.381C9.77894 4.11305 7.95128 3.35807 5.73371 3.26624C5.55843 3.25955 5.42117 3.11819 5.42117 2.94792L5.42007 1.07679L0.791324 5.5004ZM5.51961 10.9098L0.0921443 5.72261C-0.0330901 5.59652 -0.0303557 5.39465 0.0984334 5.27203L5.50211 0.108161C5.53262 0.0741153 5.57022 0.0468513 5.61239 0.0281968C5.65455 0.0095424 5.70029 -7.12578e-05 5.74656 3.97632e-07C5.92648 3.97632e-07 6.07277 0.143233 6.07277 0.319664V2.64699C8.32015 2.80201 10.1855 3.61053 11.5459 4.92935C12.979 6.31884 13.845 8.26948 13.9994 10.6142C14.0055 10.7141 13.9639 10.8153 13.8783 10.8825C13.738 10.9928 13.5332 10.9711 13.4206 10.8337C12.41 9.60248 11.2853 8.84375 10.0324 8.47054C8.84187 8.1158 7.52527 8.10376 6.07277 8.3605V10.6814C6.07195 10.7615 6.04132 10.8418 5.9798 10.9036C5.85429 11.0297 5.64812 11.0324 5.51961 10.9098Z" fill={disabled ? "#a1a1a1" : "#000"} />
            </g>
            <defs>
              <clipPath id="clip0_1594_12542">
                <rect width="14" height="11" fill="white" />
              </clipPath>
            </defs>
          </svg> {button.label}
        </div>
      ))}
    </div>
  );
};

export default WorkflowButton;
